<template>
  <div class="registration">
    <ValidationObserver v-slot="{ invalid, handleSubmit }" class="observer">
      <form class="registration-container" @submit.prevent="handleSubmit(signUp)">
             <h2 class="auth-title">Регистрация</h2>
        <div class="register-cta">
          <p class="action-text">Уже есть аккаунт?</p>
          <div class="additional-info" @click="$emit('LoginFunc')">
            <p>Войти</p>
          </div>
        </div>
        <div class="inputs">
          <BaseInput
            :placeholder="$t('auth.login')"
            v-model="login"
            rules="required|isUsername"
            type="text"
          />
          <BaseInput
            :placeholder="$t('auth.email')"
            rules="email|required"
            v-model="email"
            type="email"
          />
          <BaseInput
            :placeholder="$t('auth.password')"
            rules="required|min:8"
            v-model="password"
            vid="confirmation"
            type="password"
          />
          <BaseInput
            :placeholder="$t('auth.repeatPassword')"
            v-model="confirmPassword"
            rules="confirmed:confirmation|required"
            type="password"
          />
        </div>
        <p class="birthdate-header">Дата рождения</p>
        <div class="birth">
          <BaseSelect
            v-model="month"
            required
            selectColor="dark"
            :placeholder="$t('auth.month')"
            :options="months"
            :reduce="(el) => el.val"
            label="name"
          />
          <BaseSelect
            selectColor="dark"
            v-model="day"
            required
            :placeholder="$t('auth.day')"
            :options="days"
          />
          <BaseSelect
            selectColor="dark"
            v-model="year"
            required
            :placeholder="$t('auth.year')"
            :options="years"
          />
        </div>
        <div class="confirm-birth">
          <BaseCheckbox
            v-model="confirmBirth"
            :label="$t('auth.youMustBeToRegister')"
          />
          <BaseButton
            :disabled="invalid || conformitationRules"
            btnColor="gold"
            :label="$t('auth.signUp')"
            type="submit"
          />
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseInput from '../base/BaseInput.vue'
import BaseButton from '../base/BaseButton.vue'
import BaseSelect from '../base/BaseSelect.vue'
import BaseCheckbox from '../base/BaseCheckbox.vue'

export default {
  components: {
    BaseInput,
    BaseButton,
    BaseSelect,
    BaseCheckbox
  },

  props: {
    referral: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      email: '',
      login: '',
      password: '',
      confirmPassword: '',
      confirmBirth: false,
      month: null,
      days: [],
      day: '',
      years: [],
      year: ''
    }
  },

  created() {
    this.setDate()
  },

  computed: {
    ...mapGetters(['loading']),
    conformitationRules() {
      if (
        !this.day ||
        this.month === null ||
        this.year <= 13 ||
        !this.confirmBirth
      ) {
        return true
      }
      return false
    },
    birthDay() {
      let month = this.month
      month = month < 10 ? `0${month}` : month
      const day = this.day < 10 ? `0${this.day}` : this.day
      return `${this.year}-${month}-${day}`
    },
    formattedErrors() {
      if (this.errors) {
        const errors = []
        const obj = Object.entries(this.errors)
        for (let key of obj) {
          errors.push(key[1][0])
        }
        return errors
      }
      return null
    },
    months() {
      return [
        {val: 1, name: this.$t('date.jan')},
        {val: 2, name: this.$t('date.feb')},
        {val: 3, name: this.$t('date.mar')},
        {val: 4, name: this.$t('date.apr')},
        {val: 5, name: this.$t('date.may')},
        {val: 6, name: this.$t('date.jun')},
        {val: 7, name: this.$t('date.jul')},
        {val: 8, name: this.$t('date.aug')},
        {val: 9, name: this.$t('date.sep')},
        {val: 10, name: this.$t('date.oct')},
        {val: 11, name: this.$t('date.nov')},
        {val: 12, name: this.$t('date.dec')}
      ]
    }
  },

  watch: {
    month(newVal, oldVal) {
      this.days = []
      if (newVal === null) return
      const daysInMonth = new Date(new Date().getFullYear(), newVal, 0).getDate()
      for (let i = 0; i < daysInMonth; i++) {
        this.days.push(i + 1)
      }
    }
  },

  methods: {
    async signUp() {
      this.$store.dispatch('updateLoading', true)
      const data = {
        login: this.login,
        email: this.email,
        password: this.password,
        birthDay: this.birthDay,
        referral: this.referral
      }
      try {
        const res = await this.$api.user.register(data)
        if (res) {
          this.$store.dispatch('updateModalStatus', {
            status: true,
            name: 'success',
            message: this.$t('auth.confirmationTextMessageWasSentToYourEmail')
          })
          this.$store.dispatch('updateModalStatus', {
            status: true,
            name: 'success',
            message: this.$t('auth.checkYourEmail')
          })
          this.clearFields()
          this.$store.dispatch('openAuthModal', false)
        }
      } catch (e) {
        this.$store.dispatch('updateModalStatus', {
          status: true,
          name: 'error',
          message: e
        })
      } finally {
        this.$store.dispatch('updateLoading', false)
      }
    },
    setDate() {
      const year = new Date().getFullYear()

      const yearDiff = year - 13
      const yearsCount = 60
      this.years = Array.from(
        {length: yearsCount},
        (v, i) => yearDiff - yearsCount + i + 1
      ).reverse()
    },
    clearFields() {
      this.email = ''
      this.login = ''
      this.password = ''
      this.confirmPassword = ''
      this.confirmBirth = false
      this.month = null
      this.day = ''
      this.year = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/auth/register.scss';
</style>



// WEBPACK FOOTER //
// src/components/auth/Registration.vue